module.exports = __webpack_public_path__ + "assets/img/666710236c1c2a6737d3eab822dc64b5.24d5da31.png";